import { Col, Collapse, Row, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import TagComponent from "../../../../biblio/TagComponent";
import PdfPreview from "../../../../biblio/Modal/PdfPreview";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../../apis/store";
import { getBarCodeServicesRequests } from "../../../../apis/actions/services.actions";
import Spinner from "../../../../biblio/Loader/Spinner";
import PrimaryButton from "../../../../biblio/Buttons/PrimaryButton";
import ModalComponent from "../../../../biblio/Modal/ModalComponent";
import AddProcurationRequest from "./AddProcurationRequest";
import barcode from "../../../../assets/logo/barcode.svg";
import dayjs from "dayjs";

interface ServicesListRequestProps {
  requests: any;
}

const ServicesListRequest = ({ requests }: ServicesListRequestProps) => {
  const dispatch = useDispatch<AppDispatch>();
  const [url, setUrl] = useState<string>("");
  const [isLoading, setIsLoading] = useState<number | null>(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [procuration, setProcuration] = useState<any | null>(null);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const isMobileDevice =
        window.innerWidth <= 768 ||
        (window.innerWidth === 1024 && window.innerHeight < 1280) ||
        window.innerWidth === 1280;
      setIsMobile(isMobileDevice);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toPrint = async (id: number) => {
    setIsLoading(id);
    const barCode = (await dispatch(getBarCodeServicesRequests(id))) as any;
    const file =
      barCode?.payload?.data != null
        ? new Blob([barCode?.payload?.data], { type: "application/pdf" })
        : null;

    if (isMobile) {
      const pdfBlob = new Blob([barCode?.payload?.data], {
        type: "application/pdf",
      });
      const fileURL = URL.createObjectURL(pdfBlob);
      const link = document.createElement("a");
      link.href = fileURL;
      link.download = dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss") + ".pdf";
      link.click();
    } else {
      setUrl(file ? URL.createObjectURL(file) : "");
    }
    setIsLoading(null);
  };

  return (
    <div
      className="takaful--collapse-profile-container"
      style={{ marginTop: "2rem" }}
    >
      <div
        className={`takaful--collapse-profile takaful--collapse-label-container takaful--collapse-beneficiary-services  `}
      >
        <Collapse.Panel
          key="0"
          className=" takaful--collapse-label-panel"
          header={
            <div className="takaful--header-service-profile-container">
              <Row
                className="takaful--content-profile-box1"
                style={{ marginBottom: "0" }}
              >
                <Col
                  xxl={6}
                  xl={6}
                  lg={6}
                  md={6}
                  sm={12}
                  xs={24}
                  className="takaful--content-profile-col"
                >
                  <p className="takaful--content-services-request-p">
                    رقم الترشح
                  </p>
                </Col>
                <Col
                  xxl={6}
                  xl={6}
                  lg={6}
                  md={6}
                  sm={12}
                  xs={24}
                  className="takaful--col-content takaful--content-profile-col"
                >
                  <p className="takaful--content-services-request-p">
                    تاريخ الترشح
                  </p>
                </Col>
                <Col
                  xxl={6}
                  xl={6}
                  lg={6}
                  md={6}
                  sm={12}
                  xs={24}
                  className="takaful--col-content takaful--content-profile-col"
                >
                  <p className="takaful--content-services-request-p">الخدمة</p>
                </Col>
                <Col
                  xxl={4}
                  xl={4}
                  lg={4}
                  md={4}
                  sm={12}
                  xs={24}
                  className="takaful--col-content takaful--content-profile-col"
                >
                  <p className="takaful--content-services-request-p">المرحلة</p>
                </Col>
              </Row>
            </div>
          }
        ></Collapse.Panel>
      </div>
      <Collapse
        className={`takaful--collapse-profile takaful--collapse-beneficiary-services takaful--collapse-sponsor-requests`}
        accordion
        defaultActiveKey={["0"]}
      >
        {requests?.map((element: any, index: number) => (
          <Collapse.Panel
            className="takaful--header-profile-Panel takaful--collapse-label-panel"
            key={index}
            showArrow={false}
            header={
              <div className="takaful--header-profile-container">
                <Row
                  align={"middle"}
                  className="takaful--content-profile-box1"
                  style={{ marginBottom: "0" }}
                >
                  <Col
                    xxl={0}
                    xl={0}
                    lg={0}
                    md={0}
                    sm={12}
                    xs={12}
                    className="takaful--content-profile-col"
                  >
                    <p className="takaful--content-services-request-p">
                      رقم الترشح
                    </p>
                  </Col>
                  <Col
                    xxl={6}
                    xl={6}
                    lg={6}
                    md={6}
                    sm={12}
                    xs={12}
                    className="takaful--content-profile-col takaful--col-name-request"
                  >
                    <span className="takaful--content-services-request-span">
                      {element?.name}
                    </span>
                  </Col>
                  <Col
                    xxl={0}
                    xl={0}
                    lg={0}
                    md={0}
                    sm={12}
                    xs={12}
                    className="takaful--content-profile-col"
                  >
                    <p className="takaful--content-services-request-p">
                      تاريخ الترشح
                    </p>
                  </Col>
                  <Col
                    xxl={6}
                    xl={6}
                    lg={6}
                    md={6}
                    sm={12}
                    xs={12}
                    className="takaful--col-content takaful--content-profile-col"
                  >
                    <span className="takaful--content-services-request-span takaful--date-format">
                      {element?.date}
                    </span>
                  </Col>
                  <Col
                    xxl={0}
                    xl={0}
                    lg={0}
                    md={0}
                    sm={12}
                    xs={12}
                    className="takaful--content-profile-col"
                  >
                    <p className="takaful--content-services-request-p">
                      الخدمة
                    </p>
                  </Col>
                  <Col
                    xxl={4}
                    xl={4}
                    lg={4}
                    md={4}
                    sm={12}
                    xs={12}
                    className="takaful--col-content takaful--content-profile-col"
                  >
                    <span className="takaful--content-services-request-span">
                      {element?.service_id}
                    </span>
                  </Col>
                  <Col
                    xxl={0}
                    xl={0}
                    lg={0}
                    md={0}
                    sm={12}
                    xs={12}
                    className="takaful--content-profile-col"
                  >
                    <p className="takaful--content-services-request-p">
                    المرحلة
                    </p>
                  </Col>
                  <Col
                    xxl={6}
                    xl={6}
                    lg={6}
                    md={6}
                    sm={12}
                    xs={12}
                    className="takaful--col-content takaful--content-profile-col"
                  >
                    <TagComponent
                      className="takaful--tag-component takaful--content-services-request-tag"
                      width="70%"
                      state={element?.state}
                      orangeValue="in_progress"
                      greenValue="done"
                      redValue="cancel"
                      text={element.stage_id}
                    />
                  </Col>
                  <Col xxl={1} xl={1} lg={1} md={4} sm={4} xs={4}>
                    {element?.state === "done" &&
                      element?.product_id !== false && (
                        <div style={{ display: "flex", alignItems: "center" }}>
                          {isLoading && isLoading === element.id ? (
                            <Spinner className="takaful--print-icon" />
                          ) : (
                            <Tooltip
                              overlayClassName="takaful--share-tooltip"
                              placement="bottom"
                              title="طباعة الباركود"
                            >
                              <img
                                src={barcode}
                                alt="الباركود"
                                className="takaful--print-icon takaful--service-print-icon"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  toPrint(element.id);
                                }}
                              />
                            </Tooltip>
                          )}
                        </div>
                      )}
                  </Col>

                  {element?.need_authorization &&
                    !element?.authorization_id && (
                      <Col xxl={1} xl={1} lg={1} md={4} sm={12} xs={24}>
                        <div
                          onClick={(e) => {
                            e.stopPropagation();
                          }}
                        >
                          <PrimaryButton
                            onClick={() => {
                              setIsModalVisible(true);
                              setProcuration(element);
                            }}
                            className="takaful--add-request-btn"
                            title="توكيل"
                          />
                        </div>
                      </Col>
                    )}
                </Row>
              </div>
            }
          >
            {element?.line_ids?.length === 0 ? (
              <>
                {element?.is_received || element?.is_paid ? (
                  <Col
                    xxl={6}
                    xl={6}
                    lg={6}
                    md={6}
                    sm={12}
                    xs={24}
                    className="takaful--col-content takaful--content-profile-col"
                  >
                    <TagComponent
                      className="takaful--tag-component"
                      width="70%"
                      state={element?.state}
                      greenValue="done"
                      text={
                        element?.is_received
                          ? "تم الاستلام"
                          : element?.is_paid
                          ? "تم الصرف"
                          : ""
                      }
                    />
                  </Col>
                ) : null}

                <Row
                  className={`takaful--content-profile-box1`}
                  justify={"space-between"}
                  gutter={16}
                >
                  <Col
                    xxl={6}
                    xl={6}
                    lg={6}
                    md={6}
                    sm={6}
                    xs={6}
                    className="takaful--content-profile-col"
                  >
                    <p className="takaful--content-services-request-p">
                      {element?.product_id !== false ? "المنتج :" : "المبلغ :"}
                    </p>
                  </Col>
                  <Col
                    xxl={18}
                    xl={18}
                    lg={18}
                    md={18}
                    sm={18}
                    xs={18}
                    className="takaful--content-profile-col"
                  >
                    <span className="takaful--content-services-request-span takaful--color-span">
                      {element?.product_id !== false
                        ? element?.product_id
                        : element?.amount}
                    </span>
                  </Col>
                </Row>

                {element?.product_id !== false && (
                  <Row
                    className={`takaful--content-profile-box1`}
                    justify={"space-between"}
                    gutter={16}
                  >
                    <Col
                      xxl={6}
                      xl={6}
                      lg={6}
                      md={6}
                      sm={6}
                      xs={6}
                      className="takaful--content-profile-col"
                    >
                      <p className="takaful--content-services-request-p">
                        الكمية :
                      </p>
                    </Col>

                    <Col
                      xxl={18}
                      xl={18}
                      lg={18}
                      md={18}
                      sm={18}
                      xs={18}
                      className="takaful--content-profile-col"
                    >
                      <span className="takaful--content-services-request-span takaful--color-span">
                        {element?.quantity}
                      </span>
                    </Col>
                  </Row>
                )}
              </>
            ) : (
              <>
                {element?.is_received || element?.is_paid ? (
                  <Row>
                    <Col
                      xxl={6}
                      xl={6}
                      lg={6}
                      md={6}
                      sm={12}
                      xs={16}
                      className="takaful--col-content takaful--content-profile-col"
                    >
                      <TagComponent
                        className="takaful--tag-component"
                        width="70%"
                        state={element?.state}
                        greenValue="done"
                        text={
                          element?.is_received
                            ? "تم الاستلام"
                            : element?.is_paid
                            ? "تم الصرف"
                            : ""
                        }
                      />
                    </Col>
                  </Row>
                ) : null}

                <Row
                  className={`takaful--content-profile-box1`}
                  justify={"space-between"}
                  gutter={16}
                >
                  <Col
                    xxl={6}
                    xl={6}
                    lg={6}
                    md={6}
                    sm={6}
                    xs={6}
                    className="takaful--content-profile-col"
                  >
                    <p className="takaful--content-services-request-p">
                      {element?.product_id !== false ? "المنتج:" : null}
                    </p>
                  </Col>
                  <Col
                    xxl={18}
                    xl={18}
                    lg={18}
                    md={18}
                    sm={18}
                    xs={18}
                    className="takaful--content-profile-col"
                  >
                    <span className="takaful--content-services-request-span takaful--color-span">
                      {element?.product_id !== false
                        ? element?.product_id
                        : null}
                    </span>
                  </Col>
                </Row>

                <div className="takaful--table-service-container">
                  <table className="takaful--table">
                    <thead>
                      <tr>
                        <th style={{ width: "50%" }}>المستفيد</th>
                        <th style={{ width: "40%" }}>
                          {element.product_id !== false ? "الكمية" : "المبلغ"}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {element?.line_ids.map((el: any, index: number) => (
                        <tr key={index}>
                          <td>
                            <Row align="middle" gutter={[16, 16]}>
                              <Col xs={24} sm={24} md={24} lg={24}>
                                <span className="takaful--service-request-span">
                                  {el?.partner_id}
                                </span>
                              </Col>
                            </Row>
                          </td>
                          <td>
                            <Row align="middle" gutter={[16, 16]}>
                              <Col xs={24} sm={24} md={24} lg={24}>
                                <span className="takaful--service-request-span">
                                  {el.product_id !== false
                                    ? el?.quantity
                                    : el?.amount}
                                </span>
                              </Col>
                            </Row>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </>
            )}
          </Collapse.Panel>
        ))}
      </Collapse>
      <ModalComponent
        title=""
        open={isModalVisible}
        onClose={() => setIsModalVisible(false)}
        closeOnOutsideClick={true}
        width={800}
        modalStyle={{ top: 200 }}
      >
        <AddProcurationRequest
          setIsModalVisible={setIsModalVisible}
          authorization={procuration}
        />
      </ModalComponent>

      <PdfPreview
        open={url !== ""}
        onClose={() => setUrl("")}
        url={url}
        isBlob={true}
        className="takaful--pdf-preview-modal"
      />
    </div>
  );
};

export default ServicesListRequest;
